<!-- POI搜索组件 -->
<template>
  <!-- 隐藏的地图容器，只用于搜索功能 -->
  <div id="tMapDiv" class="hidden-map-container"></div>
</template>

<script>
import { tMapLocationPoint, tMapLocalSearch, initTMap } from '../../utils/TMapUtils.js';
import { debounce } from 'lodash';

export default {
  name: "LocalSearchComponent",
  props: {
    address: {
      type: String,
      required: true,
      default: ''
    },
    keywords: {
      type: String,
      default: ''
    },
    onLocalSearchComplete: {
      type: Function,
      required: true
    }
  },
  
  data() {
    return {
      lng: '',
      lat: '',
      isInitialized: false,
      searchDebounced: null
    };
  },
  
  created() {
    // 创建防抖搜索函数
    this.searchDebounced = debounce(this.performSearch, 500);
  },
  
  watch: {
    // 监听地址变化，获取坐标
    address: {
      immediate: true,
      handler(newAddress) {
        if (newAddress) {
          this.getCoordinates(newAddress);
        }
      }
    },
    
    // 监听关键字变化，执行搜索
    keywords(newKeywords) {
      if (this.isInitialized && this.lng && this.lat) {
        this.searchDebounced(newKeywords);
      }
    }
  },
  
  async mounted() {
    try {
      // 初始化地图
      await initTMap();
      this.isInitialized = true;
      
      // 如果已有关键字，立即搜索
      if (this.keywords && this.lng && this.lat) {
        this.performSearch(this.keywords);
      }
    } catch (error) {
      this.handleError('地图初始化失败');
    }
  },
  
  methods: {
    // 获取地址坐标
    async getCoordinates(address) {
      if (!address) return;
      
      try {
        const location = await tMapLocationPoint(address);
        if (location) {
          this.lng = location.lon;
          this.lat = location.lat;
          
          // 如果已有关键字，重新搜索
          if (this.keywords) {
            this.performSearch(this.keywords);
          }
        }
      } catch (error) {
        this.handleError('地址解析失败');
      }
    },
    
    // 执行搜索
    performSearch(keywords) {
      if (!keywords) {
        this.onLocalSearchComplete(null);
        return;
      }
      
      if (!this.lng || !this.lat) {
        this.handleError('请先选择省市区');
        return;
      }
      
      try {
        tMapLocalSearch(
          this.lng, 
          this.lat, 
          keywords, 
          'tMapDiv', 
          this.handleSearchResult
        );
      } catch (error) {
        this.handleError('搜索失败');
      }
    },
    
    // 处理搜索结果
    handleSearchResult(results) {
      this.onLocalSearchComplete(results);
    },
    
    // 错误处理
    handleError(message) {
      console.error(message);
      this.$Toast && this.$Toast.fail(message);
    }
  }
};
</script>

<style scoped>
.hidden-map-container {
  position: absolute;
  width: 100px;
  height: 100px;
  visibility: hidden;
  pointer-events: none;
}
</style>
